<template>
  <div>
    <AppHeader />
    <div class="top-ticker">
      <a href="https://wa.me/421949006016?text=Hello%2C%20I%20am%20interested%20in%20your%20off%20market%20offer." target="_blank" class="top-ticker-track notranslate" translate="no">
        <span class="top-ticker-group" v-for="n in 6" :key="n">
          <span class="top-ticker-item">
            <Icon icon="ph:fire-simple-bold" class="iconify ticker-icon" />
            More than 300+ new vehicles off market offer &mdash; Contact us
          </span>
          <span class="top-ticker-separator">/</span>
          <span class="top-ticker-item">
            <Icon icon="ph:calendar-check-bold" class="iconify ticker-icon" />
            2026 Production Models
          </span>
          <span class="top-ticker-separator">/</span>
          <span class="top-ticker-item">
            <Icon icon="ph:gauge-bold" class="iconify ticker-icon" />
            Zero or Delivery km Mileage
          </span>
          <span class="top-ticker-separator">/</span>
        </span>
      </a>
    </div>
    <main class="overflow-x-hidden position-relative">
      <router-view />
    </main>
    <AppFooter />

    <!-- AI Concierge button - bottom left -->
    <button
      class="floating-btn floating-btn--ai ai-notify floating-btn--ai-left"
      aria-label="AI Concierge"
      @click="$refs.aiConcierge.toggle()"
    >
      <img src="/storage/agent_images/WczuctaLYFehJGAsjN7DWfDUJwymKUnPCoOacJIN.png" alt="AI" style="width: 100%; height: 100%; border-radius: 50%; object-fit: cover;" />
      <span class="ai-btn-dot"></span>
    </button>

    <!-- Floating contact buttons - bottom right -->
    <div class="floating-btns" :class="{ 'floating-btns--detail': isCarDetail }">
      <a
        href="https://t.me/selectedslovakia"
        target="_blank"
        class="floating-btn floating-btn--telegram"
        aria-label="Telegram"
      >
        <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
          <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
        </svg>
      </a>
      <a
        href="https://wa.me/421949006016"
        target="_blank"
        class="floating-btn floating-btn--whatsapp"
        aria-label="WhatsApp"
      >
        <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
        </svg>
      </a>
    </div>

    <!-- AI Concierge Side Panel -->
    <AiConcierge ref="aiConcierge" />
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue';
import AppFooter from './components/AppFooter.vue';
import AiConcierge from './components/AiConcierge.vue';

export default {
  components: {
    AppHeader,
    AppFooter,
    AiConcierge
  },
  computed: {
    isCarDetail() {
      return this.$route && this.$route.path.startsWith('/car/');
    }
  }
};
</script>

<style>
/* Top ticker */
.top-ticker {
  background: #fff;
  overflow: hidden;
  white-space: nowrap;
  position: sticky;
  top: 6.25rem;
  z-index: 10;
}

@media (max-width: 991px) {
  .top-ticker {
    top: 4.25rem;
  }
}

.top-ticker-track {
  display: inline-flex;
  animation: ticker-scroll 30s linear infinite;
  text-decoration: none;
}

.top-ticker-group {
  display: inline-flex;
  align-items: center;
}

.top-ticker-item {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 6px 0;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #000;
  white-space: nowrap;
}

.ticker-icon {
  font-size: 0.8rem;
  color: #000;
}

.top-ticker-separator {
  padding: 0 1.5rem;
  color: rgba(0, 0, 0, 0.25);
  font-size: 0.7rem;
  font-weight: 300;
}

@keyframes ticker-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.top-ticker:hover .top-ticker-track {
  animation-play-state: paused;
}

@media (max-width: 767px) {
  .top-ticker-item {
    font-size: 0.6rem;
    padding: 5px 0;
  }
  .top-ticker-separator {
    padding: 0 1rem;
  }
  .ticker-icon {
    font-size: 0.7rem;
  }
}

/* Floating contact buttons */
.floating-btns {
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 9990;
}

.floating-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #fff;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
}

.floating-btn--ai {
  width: 56px;
  height: 56px;
  padding: 0;
  overflow: visible;
  background: #fff;
  border: 2px solid rgba(255,255,255,0.9);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  position: relative;
}
.floating-btn--ai img {
  border-radius: 50%;
}
.floating-btn--ai-left {
  position: fixed;
  bottom: 24px;
  left: 24px;
  z-index: 9990;
}
@media (max-width: 767px) {
  .floating-btn--ai {
    width: 50px;
    height: 50px;
  }
  .floating-btn--ai-left {
    bottom: 20px;
    left: 16px;
  }
}
.floating-btn--ai:hover {
  border-color: #25d366;
}

.floating-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
}

.floating-btn--whatsapp {
  background: #25d366;
}

.floating-btn--telegram {
  background: #2aabee;
}

/* Car detail page: sticky centered vertically on right */
.floating-btns--detail {
  position: fixed;
  bottom: auto;
  top: 50%;
  transform: translateY(-50%);
  right: 24px;
}

@media (max-width: 767px) {
  .floating-btns {
    bottom: 16px;
    right: 16px;
    gap: 8px;
  }
  .floating-btn {
    width: 44px;
    height: 44px;
  }
  .floating-btns--detail {
    top: 50%;
    bottom: auto;
    right: 12px;
    transform: translateY(-50%);
  }
}
</style>
